import isString from 'lodash/isString';
import {HeaderMenuLeftItemProps} from './headerMenuTypes';

export function hasHref(src: any): src is HeaderMenuLeftItemProps {
  return isString(src.name) && isString(src.href) && src.name.length && src.href.length;
}
